import React from 'react'
import { useContext } from '../Context'
import { PopUpContainer } from '../../../../components/header/quick-create/PopUpContainer'
import { MenuPopUpEnum } from '../MenuPopUpEnum'
import { AddForm } from '../../../add-logistics/AddForm'
import type { Logistic, NextFunction } from '@ztechapps/common.contract'
import { useError } from '@ztechapps/common.hook'
import { routesDef } from '../../../../config/routes'

export const LogisticsPopUp = () => {
  const { menuTarget, open, onSuccessSubmit } = useContext()
  const { onError } = useError()

  const next: NextFunction<Logistic> = async (data, error) => {
    if (error) {
      onError(error)
      return
    }

    onSuccessSubmit(routesDef.LogisticItemPage.altPath({ _id: data?._id }))
  }

  return (
    <PopUpContainer show={menuTarget?.show === MenuPopUpEnum.logistics && open} target={menuTarget?.target}>
      <AddForm next={next} formButtons="save-only" />
    </PopUpContainer>
  )
}
